var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hasType)?_c('span',[_vm._v(" ")]):(_vm.hasTo || _vm.hasLink)?_c(_vm.component,{tag:"component",class:[
    `wrapper--box-card-${_vm.item.type}`,
    _vm.isProduct ? `wrapper--box-card-product` : '',
  ],attrs:{"shadow":_vm.shadow,"is-product":_vm.isProduct,"to":_vm.hasTo ? _vm.to : {},"link":_vm.hasLink ? _vm.link : '',"target":_vm.hasLink ? _vm.target : '',"item":_vm.item,"base":_vm.base,"lazy":_vm.lazy}}):(_vm.hasType)?_c(_vm.component,{tag:"component",attrs:{"shadow":_vm.shadow,"is-product":_vm.isProduct,"item":_vm.item,"base":_vm.base,"lazy":_vm.lazy}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }